import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IonicModule } from '@ionic/angular';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { CopyToClipboardModule } from 'ngx-zcs-components';

import { SystemsListComponent } from './systems-list.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { PlantCardOverviewModule } from '../plant-card-overview/plant-card-overview.module';
import { SearchComponent } from '../components/search/search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AlertsCounterModule } from '../alerts/alerts-counter/alerts-counter.module';

@NgModule({
  declarations: [
    SystemsListComponent,
  ],
  imports: [
    AlertsCounterModule,
    BlockTitleComponent,
    CommonModule,
    CopyToClipboardModule,
    FormsModule,
    IonicModule,
    MatCheckboxModule,
    MatIconModule,
    MatPaginatorModule,
    MatTableModule,
    PlantCardOverviewModule,
    ReactiveFormsModule,
    SearchComponent,
  ],
  exports: [
    SystemsListComponent,
  ],
})
export class SystemsListsModule { }
